import React, { HTMLAttributes } from "react";
import { GetStaticProps } from "next";
import { Util } from "@xt/xtbase";
const { getOrigin } = Util;
import { get_tdk } from "api/server/tdk";
import Layout from "components/Layout";
import Verify from "components/Pages/verify";
interface Props extends HTMLAttributes<HTMLDivElement> {
  attr?: any;
  tdk?: any;
  resolvedUrl: string;
}
const index: React.FC<Props> = () => {
  //const t = useTranslation();
  return (
    <Layout>
      <Verify />
    </Layout>
  );
};
export default index;
export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const resolvedUrl = "/verify";
  const props: Props = { resolvedUrl };
  try {
    const tdkUrl = getOrigin("www") + "/" + locale + resolvedUrl;
    const tdk = await get_tdk({
      params: {
        url: tdkUrl,
        languageType: locale == "zh-CN" ? "cn" : locale == "zh-HK" ? "hk" : locale,
      },
    });
    props.tdk = tdk || {};
  } catch (error) {
    console.log("get tdk error");
    console.log(error);
    props.tdk = {};
  }
  return {
    props,
    revalidate: 60,
  };
};
